import Vue from 'vue'

export const CHANGE_PAGE = (state, page) => {
  state.config[state.resourceType].page = page
}

export const SET_PER_PAGE = (state, perPage) => {
  state.config[state.resourceType].perPage = perPage
}

export const SET_RESOURCE_TYPE = (state, type) => {
  state.resourceType = type
}

export const SET_SORT_FIELD = (state, sortField) => {
  state.config[state.resourceType].sortField = sortField
}

export const SET_SORT_ORDER = (state, sortOrder) => {
  state.config[state.resourceType].sortOrder = sortOrder
}

export const UPDATE_FILTER = (state, updatedFilter) => {
  state.filter[state.resourceType] = updatedFilter
}

export const UPDATE_LIST_SCHEMA_FIELDS = (state, updatedListSchemaFields) => {
  Vue.set(state.listSchema[state.resourceType], 'fields', updatedListSchemaFields)
}

export const PREFILL_ORGA = (state, orga) => {
  for (let [entity, bit] of Object.entries(state.filterSchema)) {
    if (bit.fields.some(x => x.field === 'organisationseinheit')) {
      Vue.set(state.filter[entity], 'organisationseinheit', orga)
    }
  }
}

export const TOGGLE_COLUMNS = (state, columns) => {
  for (let field of state.listSchema[state.resourceType].fields) {
    if (columns.includes(field.field)) {
      field.tableVisible = true
    } else {
      field.tableVisible = false
    }
  }
}

export const RESET_LIST = (state) => {
  state.data = {}
  state.id = null
  state.resourceType = 'forschungsprojekt'
  state.filter = {
    forschungsprojekt: {
      kumuliert: false
    },
    kooperation: {
      kumuliert: false
    },
    publikation: {
      kumuliert: false
    },
    person: {},
    organisationseinheit: {},
    abstractperson: {},
    veranstaltung: {
      kumuliert: false
    },
    preis: {
      kumuliert: false
    },
    externeorganisation: {},
    patent: {
      kumuliert: false
    },
    land: {},
    appuser: {}
  }
  state.config = {
    forschungsprojekt: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    kooperation: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    publikation: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    veranstaltung: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    preis: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    abstractperson: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    organisationseinheit: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    person: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    externeorganisation: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    patent: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    land: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    appuser: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/list/mutations.js